import { render, staticRenderFns } from "./UserResetPasswordNoFactors.vue?vue&type=template&id=3c2f4a24"
import script from "./UserResetPasswordNoFactors.vue?vue&type=script&lang=ts"
export * from "./UserResetPasswordNoFactors.vue?vue&type=script&lang=ts"
import style0 from "./UserResetPasswordNoFactors.vue?vue&type=style&index=0&id=3c2f4a24&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports